import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=58ad6030"
import script from "./WidgetForm.vue?vue&type=script&lang=js"
export * from "./WidgetForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetForm.vue?vue&type=style&index=0&id=58ad6030&prod&lang=css"
import style1 from "./WidgetForm.vue?vue&type=style&index=1&id=58ad6030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports